import { Col, Row } from "react-bootstrap";
import { useNavigate } from "react-router-dom";

import backIcon from "../../assets/images/back-icon.svg";
import "./RootLayout.css";

type RootLayoutProps = {
  children: React.ReactNode;
  title: string;
  subtitle: string;
  logo: string;
  logoAlt: string;
  showBackButton?: boolean;
};

export default function RootLayout({
  children,
  title,
  subtitle,
  logo,
  logoAlt,
  showBackButton,
}: RootLayoutProps) {
  const navigate = useNavigate();

  return (
    <>
      <main className="container-fluid">
        <div className="main main-app p-3 p-lg-4">
          {showBackButton && <button onClick={() => navigate(-1)} className="back-button">
            <img src={backIcon} alt="Back" />
            <span>Go Back</span>
          </button>}
          <Row className="align-items-center text-center text-md-start rootApp-header">
            <Col md={6}>
              <h2 className="rootApp-title">{title}</h2>
              <p className="rootApp-subtitle">{subtitle}</p>
            </Col>
            <Col md={6} className="text-center position-relative">
              <img
                src={logo}
                className="img-fluid rootApp-logo"
                alt={logoAlt}
              />
            </Col>
          </Row>
          <div className="mt-4 bg-white p-5 rootApp-subcontainer">
            {children}
          </div>
        </div>
      </main>
    </>
  );
}
